module.exports = __webpack_public_path__ + "static/lachat_mario_3-ec0defacd9571372ce254cc44c1cffbb.png";